export default __webpack_public_path__ + "static/media/Blog23.2897db80.jpg";